// extracted by mini-css-extract-plugin
module.exports = {"TriangleImage":"styles_TriangleImage__nUxXr","top-right":"styles_top-right__xR52J","top-left":"styles_top-left__8cFdY","bottom-left":"styles_bottom-left__JU3TI"};